import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { getRootCategories } from '../../../../crud/categories.crud';
import { ICategoryItem } from '../../categories/interfaces';

export const useGetRootsCategories = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<ICategoryItem[] | null>([]);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });

  const fetch = async (data: {
    page?: number;
    per_page?: number;
    parentId?: number;
    text?: string;
    only_active?: number;
    with_products?: number;
  }) => {
    setLoading(true);
    getRootCategories(data)
      .then((res: any) => {
        setCategories(res.data.data);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, per_page, total } = res.data;
        setPage({ page, perPage: per_page, total });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { fetch, loading, categories, page };
};
